import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FHIRProcedure } from '../../../../models';

@Component({
  selector: 'app-procedures-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './procedures-section.component.html',
})
export class ProceduresSectionComponent {
  readonly procedures = input.required<FHIRProcedure[]>();

  formatDate(date: string): string {
    if (!date) return '—';
    return /^\d{4}-\d{2}-\d{2}/.test(date) ? date.slice(0, 10) : date;
  }

  getStatusBadge(status: string): { color: string; label: string } {
    const s = (status || '').toLowerCase();
    if (s === 'completed') return { color: 'bg-success', label: 'Completado' };
    if (s === 'in-progress') return { color: 'bg-primary', label: 'En Progreso' };
    if (s === 'not-done') return { color: 'bg-danger', label: 'No Realizado' };
    if (s === 'preparation') return { color: 'bg-warning text-dark', label: 'En Preparación' };
    if (s === 'on-hold') return { color: 'bg-warning text-dark', label: 'En Espera' };
    if (s === 'stopped') return { color: 'bg-danger', label: 'Detenido' };
    if (s === 'entered-in-error') return { color: 'bg-danger', label: 'Error de Entrada' };
    if (s === 'unknown') return { color: 'bg-secondary', label: 'Desconocido' };
    return { color: 'bg-secondary', label: status || '—' };
  }

  getProcedureName(proc: FHIRProcedure): string {
    return proc.code?.text || proc.code?.coding?.[0]?.display || '—';
  }

  getProcedureCode(proc: FHIRProcedure): string {
    return proc.code?.coding?.[0]?.code || '';
  }

  getPerformedDate(proc: FHIRProcedure): string {
    return proc.performedDateTime || proc.performedPeriod?.start || '';
  }
}
